// Dev-facing signal that global-wrapper-service rejected an expressions request
// with a 400, which always means misconfiguration (bad context, bad template or
// invalid expression). Only active on b1-prv so end users never see it.
const ENABLED_DATACENTER = 'b1-prv';

export const BAD_REQUEST_STATUS = 400;

// Expressions are evaluated outside React, possibly before the banner mounts,
// so the flag lives here and the banner mirrors it into its own state.
let hasBadRequest = false;
let datacenter: string | undefined;
let onBadRequest: (() => void) | null = null;

// Fed from the bundle's system.dc (see initialization-service) so datacenter
// detection stays in one place.
export const setBadRequestDatacenter = (dc?: string): void => {
  datacenter = dc;
};

const isEnabled = (): boolean => datacenter === ENABLED_DATACENTER;

export const reportBadRequest = (): void => {
  if (!isEnabled() || hasBadRequest) {
    return;
  }
  hasBadRequest = true;
  onBadRequest?.();
};

export const hasReportedBadRequest = (): boolean => hasBadRequest;

// Only the banner registers, so a single slot is enough.
export const registerBadRequestHandler = (
  handler: () => void,
): (() => void) => {
  onBadRequest = handler;
  return () => {
    onBadRequest = null;
  };
};

export const resetBadRequest = (): void => {
  hasBadRequest = false;
  datacenter = undefined;
};
